import api from '../../tools/api-tools'
import { fullImgPath } from '../../tools/img-tools'
import resUrl from './resource-url'
import Ticket from '../tickets'

// import './index.mock'
class HardwareMarket {
  loadData () {
    return new Promise((resolve, reject) => {
      Promise.all([
        api.get(resUrl.index),
        new Ticket().loadData(),
        api.get(resUrl.banners)
      ]).then(values => {
        let goodItemData = values[0].data.data || []
        let bannerData = values[2].data.data || {}
        let goodsItem = []
        let banners = []
        // banner
        if ('items' in bannerData) {
          for (let item of bannerData.items) {
            let nowLink = this._getTurl(item.link)
            banners.push({
              image: item.image,
              link: nowLink
            })
          }
        }
        // 每个商品item
        for (let item of goodItemData) {
          goodsItem.push({
            id: item.id,
            goodsId: item.goodsId,
            img: fullImgPath(item.coverImage[0].picUrl),
            title: item.aliasName,
            price: item.price
          })
        }
        resolve({goodsItem, banners})
      }).catch((e) => {
        reject(e)
      })
    })
  }

  loadDetail (id) {
    return new Promise((resolve, reject) => {
      api.get(resUrl.detail + id).then(res => {
        let data = res.data.data || {}
        let banners = []
        let goodsInfo = {
          title: data.aliasName,
          desc: data.subTitle,
          icon: fullImgPath(data.coverImage[0].picUrl),
          price: data.price,
          detailImages: [],
          detailText: data.specification.replace(/\n|\r\n/g, '<br>'),
          isCouponUnAvaliable: data.isCouponUnAvaliable,
          isIntegralUnAvaliable: data.isIntegralUnAvaliable
        }
        for (let item of data.description) {
          goodsInfo.detailImages.push(fullImgPath(item.picUrl))
        }
        for (let item of data.headThumb) {
          banners.push(fullImgPath(item.picUrl))
        }
        resolve({banners, goodsInfo})
      }).catch(e => {
        reject(e)
      })
    })
  }

  _getTurl (link) {
    let turl = link.indexOf('turl=') > 0 ? link.substring(link.indexOf('turl=') + 5) : ''
    return JSON.parse(turl.length ? decodeURIComponent(turl).replace(/###/g, '') : '{}')
  }
}

export default HardwareMarket



// WEBPACK FOOTER //
// ./src/model/hardware-market/index.js